export const prologueFirstDialogues: any[] = [
    {
        id: 1,
        dialogue: [
            `Emily: "Dad, where did I put my red hoodie? I can't find it anywhere!"
            <
            Alex: "Hmm, did you check the laundry room, Em? I'm pretty sure i saw it there yesterday."
            <
            [You hear Emily running towards the laundry room.]`,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 2,
        dialogue: [
            `
You see Emily running back to you from the laundry room with a hoodie in her hand.
<
Emily: "Oh, yeah! I found it! Thanks, Dad!"
<
Alex: "No problem, kiddo. Remember to pack some warm clothes too. It might get chilly in Havenwood."
<
Emily: "Got it, Dad! Can I bring my sketchbook with me?"
<
Alex: "Of course, Em. It's important to have things that make you happy on the trip."
<
Emily: "Yay! Thanks, Dad! I can't wait to draw all the trees and animals in Havenwood."
<
Alex: "Sounds like a plan, sweetheart. Now, let's make sure we have enough snacks for the road. What do you feel like having?"
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 3,
        dialogue: [
            `
        Emily: "Hmm... I want some cheese crackers and fruit snacks, please!"
<
Alex: "Alright, cheese crackers and fruit snacks it is. Anything else you want to bring?"
<
Emily: "Ehm... 
<
YOU!"
<
*Alex laughs and smiles at Emily*
<
Alex:  "Absolutely kiddo, i will drag myself along."
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 4,
        dialogue: [
            `
        Alex: “Alright i think we're ready to go Em.”
        <
Emily: “Yes!.. lets hit the road Jack!”
<
*Emily giggles*
<
Alex: “Em, you can bring your stuff to the car, it should be unlocked. I will be there in a minute.”
<
Emily: “Okay dad.”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 5,
        dialogue: [
            `
        You do some last checks in the house before leaving..
        <
Alex: “Okay, i think i got everything.”
<
You look around the house one more time..
<
Alex: “The pocket knife!
<
I bet dad would love to see that i still have it.
<
It's been a while since i saw him though, atleast like 5 years..
maybe he doesn't care.”
        `,
        ],
        options: [
            { id: 1, action: "Bring the pocket knife", roomId: 1 },
            { id: 2, action: "Leave without the pocket knife", roomId: 1 },
        ],
    },
    {
        id: 6,
        dialogue: [
            `
As you leave the house, you lock the door behind. You walk to the car and store you baggage in the trunk. You enter the car and see Emily sitting in the front passenger's seat.
<
Alex: “Im excited for this trip Em, are you all set?”
<     
Emily: “Yes, i'm super ready!”
< 
You start the car and drive off.
<    
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 7,
        dialogue: [
            `Emily: "Dad, where did I put my red hoodie? I can't find it anywhere!"
            <
            Alex: "Hmm, did you check the laundry room, Em? I'm pretty sure i saw it there yesterday."
            <
            [You hear Emily running towards the laundry room.]`,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 8,
        dialogue: [
            `
You see Emily running back to you from the laundry room with a hoodie in her hand.
<
Emily: "Oh, yeah! I found it! Thanks, Dad!"
<
Alex: "No problem, kiddo. Remember to pack some warm clothes too. It might get chilly in Havenwood."
<
Emily: "Got it, Dad! Can I bring my sketchbook with me?"
<
Alex: "Of course, Em. It's important to have things that make you happy on the trip."
<
Emily: "Yay! Thanks, Dad! I can't wait to draw all the trees and animals in Havenwood."
<
Alex: "Sounds like a plan, sweetheart. Now, let's make sure we have enough snacks for the road. What do you feel like having?"
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 9,
        dialogue: [
            `
        Emily: "Hmm... I want some cheese crackers and fruit snacks, please!"
<
Alex: "Alright, cheese crackers and fruit snacks it is. Anything else you want to bring?"
<
Emily: "Ehm... 
<
YOU!"
<
*Alex laughs and smiles at Emily*
<
Alex:  "Absolutely kiddo, i will drag myself along."
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 10,
        dialogue: [
            `
        You do some last checks in the house before leaving..
        <
Alex: “Okay, i think i got everything.”
<
You look around the house one more time..
<
Alex: “The pocket knife!
<
I bet dad would love to see that i still have it.
<
It's been a while since i saw him though, atleast like 5 years..
maybe he doesn't care.”
        `,
        ],
        options: [{ id: 1, action: "Continue..", roomId: 1 }],
    },
    {
        id: 11,
        dialogue: [
            `
As you leave the house, you lock the door behind. You walk to the car and store you baggage in the trunk. You enter the car and see Emily sitting in the front passenger's seat.
<
Alex: “Im excited for this trip Em, are you all set?”
<     
Emily: “Yes, i'm super ready!”
< 
You start the car and drive off.
<    
        `,
        ],
        options: [{ id: 1, action: "Restart scene..", roomId: 1 }],
    },
    {
        id: 99,
        dialogue: [
            `
Exit prologue 1, enter prologue 2.
        `,
        ],
        options: [],
    },
];

export const introduction: string = `
Welcome to "Into the Shadows", a gripping narrative text-based adventure game where you take on the role of Alex, 

a 34-year-old man, on a journey with his daughter, Emily. After a rough divorce, Alex and Emily look to reconnect with one another by going on a road trip visiting Alex's parents in the town called Havenwood.

During the adventure you'll unravel mysteries, confront past mistakes, and navigate challenges that test the strength of your bond. Get ready for an immersive experience where every choice matters as you delve into the shadows of Alex's past. Are you prepared to face what lies ahead?
`;
